import { Component, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-action-button-with-embedded-spinner',
    templateUrl: './action-button-with-embedded-spinner.component.html',
    styleUrls: ['./action-button-with-embedded-spinner.component.scss']
})
export class ActionButtonWithEmbeddedSpinnerComponent implements OnInit {
    showSpinner: boolean = false;

    @Input()
    actionObservable: () => Observable<any>;

    @Input()
    icon: string;

    @Input()
    hint: string;

    @Input()
    disabled: boolean = false;

    constructor() {}

    ngOnInit(): void {}

    doAction() {
        this.showSpinner = true;
        this.actionObservable()
            .pipe(
                catchError(err => {
                    console.log('ActionButtonWithEmbeddedSpinnerComponent.doAction => ERROR:');
                    console.log(err);
                    return of(null);
                })
            )
            .subscribe(() => {
                this.showSpinner = false;
            });
    }
}
